import React, {Component} from 'react';
import {connect} from 'react-redux';
import AiYearLogo from '../AiYearLogo';
import SocialLink from '../SocialLink';

const design = {
	signature: {
		minWidth: '500px',
		maxWidth: '600px'
	},
	headerSection: {
		display: 'flex',
		width: '100%',
	},
	imageSection: {
		width: '150px',
		flex: '0 0 150px',
		textAlign: 'center',
	},
	image: {
		maxWidth: '80px',
		margin: '7px',
	},
	detailsSection: {
		flex: 1,
		width: '100%',
		textAlign: 'right',
	},
	detailRow: {
		width: '100%',
	},
	footerSection: {
		vision: {
			maxWidth: '90px',
		},
		icon: {
			color: '#b3b3b3',
		},
		ksu: {
			width: '200px',
			display: 'flex',
			alignItems: 'center',
		},
		ksuRtl: {
			display: 'flex',
			alignItems: 'center',
			flex: '0 0 auto',
		},
		ksuLogo: {
			width: '110px',
			display: 'block',
			flex: '0 0 auto',
		},
		aiYearLogoRtl: {
			width: '80px',
			marginRight: '10px',
			flex: '0 0 auto',
		},
	},
	line: {
		row: {
			display: 'flex',
			width: '100%',
		},
		leftSection: {
			height: '7px',
			width: '150px',
			flex: '0 0 150px',
			backgroundColor: '#b3b3b3',

		},
		rightSection: {
			height: '7px',
			flex: 1,
			backgroundColor: '#0083b5',

		},
	},
	footerRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		width: '100%',
	},
	socialIcons: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '5px',
	},
	clearFix: {
		clear: 'both',
	},
	bottomFooter: {
		style: {
			display: 'flex',
			width: '100%',
		},
	},
};

class KsuOneTemplateRTL extends Component {

	render() {
		return (
				<div style={design.signature} data-signature-root="true">
					<div style={design.headerSection}>
						<div style={design.imageSection}>
							<img alt={this.props.name} src={this.props.imageName} style={design.image}/>
						</div>
						<div style={design.detailsSection}>
							<div style={{...design.detailRow, fontWeight: 'bold'}}>
								{!this.props.flag ? 'محمد عبدالله' : this.props.name}
							</div>
							<div style={{...design.detailRow, color: '#0083b5'}}>
								{!this.props.flag ? 'الوظيفة  |  ' : this.props.jobTitle} {this.props.jobTitle === '' ? '' : '  |  '}
								{!this.props.flag ? 'القسم' : this.props.department}
							</div>
							<div style={design.detailRow}>
								{!this.props.flag ?
									<>
										<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} />
										&nbsp;
										011/055
									</> :
									<>
										<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} hidden={this.props.mobile === ''}/>
										&nbsp;
										{this.props.mobile}
									</>}
							</div>
							<div style={design.detailRow}>
								{!this.props.flag ?
									<>
										<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'}/>
										&nbsp;
										m.abdullah@ksu.edu.sa
									</> :
									<>
										<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'} hidden={this.props.email === ''}/>
										&nbsp;
										{this.props.email}
									</>}

							</div>
							<div style={design.detailRow}>
								{!this.props.flag ? 'https://ksu.edu.sa' : this.props.website}
							</div>
						</div>
					</div>
					<div style={design.line.row}>
						<div style={design.line.leftSection}/>
						<div style={design.line.rightSection}/>
					</div>
					<div style={design.bottomFooter.style}>
						<div style={design.footerRow}>
							<div className='mr-3' style={design.footerSection.ksuRtl}>
								<img className='mt-2' style={design.footerSection.vision} src={`${process.env.PUBLIC_URL}/saudi-vision-2030.png`}  alt={'vision'}/>
								<AiYearLogo style={design.footerSection.aiYearLogoRtl}/>
							</div>
							<div style={design.socialIcons}>
								{!this.props.flag ?
								<div className='f-flex'>
									<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com'>
										<img className='mr-1' style={{width:'20px'}} src={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'}/>
									</a>
								</div>
								: (this.props.linkedin !== '' && <SocialLink href={this.props.linkedin} icon={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'} width={'20px'}/>)}
								{!this.props.flag ?
								<div className='f-flex gap-2'>
									<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.x.com'>
										<img className='mr-1' style={{width:'20px'}}  src={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'}/>
									</a>
								</div>
								: (this.props.twitter !== '' && <SocialLink href={this.props.twitter} icon={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'} width={'20px'}/>)}

								{!this.props.flag ?
									<div className='f-flex gap-2'>
										<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/'>
											<img style={{width:'20px'}}  src={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'}/>
										</a>
									</div>
									: ( this.props.facebook !== '' && <SocialLink href={this.props.facebook} icon={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'} width={'20px'}/>)}
							</div>
						</div>
						<div style={design.footerSection.ksuRtl}>
							<img className='mt-2' style={design.footerSection.ksuLogo} src={`${process.env.PUBLIC_URL}/ksu-logo.png`}  alt={'ksu-logo'}/>
						</div>
					</div>
				</div>

		);
	};
};

function mapStateToProps(state) {
	return {
		flag: state.ArabicReducer.flag,
		name: state.ArabicReducer.ar_name,
		email: state.ArabicReducer.ar_email,
		jobTitle: state.ArabicReducer.ar_jobTitle,
		department: state.ArabicReducer.ar_department,
		mobile: state.ArabicReducer.ar_mobile,
		website: state.ArabicReducer.ar_website,
		imageName: state.imageReducer.image,
		linkedin: state.socialReducer.linkedin,
		twitter: state.socialReducer.twitter,
		facebook: state.socialReducer.facebook,
		github: state.socialReducer.github,
	};
}

export const ksuOneTemplateRTL = connect(mapStateToProps)(KsuOneTemplateRTL);
